import React from 'react';

import { faExclamationCircle, faPlus } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'shared/empty_state';
import LoadingSpinner from 'components/ui/loading_spinner';
import Task from '../task';
import { useTasks } from '../context/tasks_context';
import classNames from 'classnames';

export function TasksList() {
  const {
    addTaskAttachment,
    currentParent,
    deleteTask,
    features,
    forUser,
    hideAssignees,
    inline,
    loading,
    options,
    paths,
    removeTaskAttachment,
    selectedTask,
    showModal,
    showParents,
    showTaskModal,
    tasks,
    updateTask,
  } = useTasks();

  let body;
  if (loading) {
    body = (
      <tr>
        <td colSpan={99}>
          <div className="mb-4">
            <LoadingSpinner/>
          </div>
        </td>
      </tr>
    );
  } else {
    body = <>
      {tasks.map(task => (
        <Task
          active={task.id === selectedTask?.id && showModal}
          addTaskAttachment={addTaskAttachment}
          attachmentsPath={paths.attachments}
          currentParent={currentParent}
          deleteTaskAttachment={removeTaskAttachment}
          features={features}
          forUser={forUser}
          hideAssignee={hideAssignees}
          key={task.id}
          modalOpen={showModal}
          options={options}
          showParents={showParents}
          task={task}
          onClick={showTaskModal}
          onDelete={deleteTask}
          onUpdate={updateTask}
        />
      ))}
    </>;
  }

  return <>
    <div className="table-container">
      <table className={classNames('table table-responsive table-hover table-sm', { 'table-sticky': inline })}>
        <thead className={classNames({ 'sticky-heading': inline })}>
          <th className="ps-6" colSpan={2}>Task</th>
          {showParents && <th>Source</th>}
          <th>Due Date</th>
          {!hideAssignees && <th>Assignee</th>}
          <th>Attachments</th>
        </thead>
        <tbody>
          {body}
        </tbody>
      </table>
    </div>
    {!loading && tasks.length === 0 && <TasksEmptyState/>}
  </>;
}

export function TasksEmptyState() {
  const { inline, paths, showTaskModal } = useTasks();

  const content = (
    <EmptyState
      bodyText={
        paths.create
          ? 'Create your first task to get started'
          : 'Tasks created via Contacts, Deals or Listings will populate here'
      }
      buttonIcon={faPlus}
      buttonText="New Task"
      header="No tasks to display"
      icon={faExclamationCircle}
      plainButton={false}
      onClick={paths.create ? () => showTaskModal() : undefined}
    />
  );

  return inline ? <div className="p-4 bg-white">{content}</div> : content;
}
